<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { computed } from "vue";
import { cn } from "@/lib/utils";

const props = defineProps<{
  input: unknown;
  class?: HTMLAttributes["class"];
}>();

const formattedInput = computed(() => {
  try {
    return JSON.stringify(props.input, null, 2);
  } catch {
    return String(props.input);
  }
});
</script>

<template>
  <div :class="cn('space-y-2 overflow-hidden p-4', props.class)" v-bind="$attrs">
    <h4 class="font-medium text-muted-foreground text-xs uppercase tracking-wide">Parameters</h4>
    <pre
      class="overflow-x-auto rounded-md bg-muted/50 p-3 text-xs text-foreground"
    ><code>{{ formattedInput }}</code></pre>
  </div>
</template>
